export default __webpack_public_path__ + "static/media/iconfinder_google_firebase_1175544.addf245d.png";